;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';

import { shouldCreateSpanForRequest, tagApolloError } from './utils/capture';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_NODE_ENV,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({ shouldCreateSpanForRequest }),
    ],
    ignoreErrors: [
      // Thrown by the script the Facebook Android in-app browser injects
      // (navigation_performance_logger_android) when its native bridge is
      // torn down on beforeunload. Not our code and not user-facing.
      'Java object is gone',
      // The iOS twin: the Instagram in-app browser's injected
      // sendPageHideMessage script reads window.webkit.messageHandlers on
      // pagehide after its native bridge is gone. Not our code either.
      'window.webkit.messageHandlers',
    ],
    beforeSend: tagApolloError,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
